// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap; // Make it globally available

// https://github.com/basecamp/local_time#installation
import LocalTime from "local-time"
LocalTime.start()

// https://getbootstrap.com/docs/5.1/components/popovers/#example-enable-popovers-everywhere
// let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))  
// let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {  
//   return new bootstrap.Popover(popoverTriggerEl)  
// })  

// https://getbootstrap.com/docs/5.1/components/tooltips/#example-enable-tooltips-everywhere
// var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//   return new bootstrap.Tooltip(tooltipTriggerEl)
// })


// init Tooltips everywhere, with turbo
// see: https://blog.konoson.com/make-javascript-work-seamlessly-with-or-without-turbo-in-ruby-on-rails
const initTooltips = () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(element => {
        new bootstrap.Tooltip(element);
    });
};
document.addEventListener('DOMContentLoaded', initTooltips, { once: true });
document.addEventListener('turbo:render', initTooltips);

// init Tooltips everywhere, with turbo
const initPopovers = () => {
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(element => {
        new bootstrap.Popover(element);
    });
};
document.addEventListener('DOMContentLoaded', initPopovers, { once: true });
document.addEventListener('turbo:render', initPopovers);